import React from 'react';

export const BUILDBROZ_LOGO_URL =
  'https://customer-assets.emergentagent.com/job_homecraft-17/artifacts/3fqxm7r4_BuildBroz_Logo.png';

export const DEFAULT_PAGE_TITLE = "BuildBroz | Let's Build It";

export const usePageTitle = (title) => {
  React.useEffect(() => {
    document.title = title;
    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [title]);
};
